import toastr from 'toastr'
import { hasPermits } from 'directives'

const directives = {
  hasPermits
}

const components = {
}

const filters = {
}

const computed = {
}

const watch = {
  formActive () {
    this.errors = {};
  }
}

const methods = {
  submit () {
    this.processing = true;
    let data = _.cloneDeep(this.form);
    this.errors = {};
    data.send_new_location_email = Number(data.send_new_location_email);

    this.$store.dispatch('externalEmail.new', data).then(() => {
      let errors = _.cloneDeep(this.$store.state.externalEmail.errors);
      if (errors) {
        this.errors = errors.errors;
        toastr.error(errors.message);
      } else {
        toastr.success('email added successfully');
        this.formActive = false;
        this.clearForm()
      }
      this.processing = false;
    });
  },

  clearForm () {
    this.form.email = '';
    this.form.send_new_location_email = false;
  },

  
}

export default {
  name: 'add-external-email',
  computed,
  methods,
  components,
  filters,
  watch,
  directives,
  data () {
    return {
      formActive: false,
      loading: false,
      processing: false,
      form: {
        email:'',
        send_new_location_email: false,
      },
      errors: {},
    }
  }
}
